import prod from './environment.production';
import dev from './environment.local';

const config = process.env.REACT_APP_STAGE === 'production' ? prod : dev;

export default config;
